import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import { LogIn, Lock, Mail, Loader2 } from 'lucide-react';
import { adminApi, auth } from '../utils/api';
import { PasswordInput } from '../components/PasswordInput';
import { SEO } from '../components/SEO';

export const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await adminApi.login(email, password);
      const { token, admin } = response.data;
      
      auth.setToken(token);
      auth.setAdminInfo(admin);
      
      toast({
        title: "Giriş uğurlu oldu",
        description: "Admin panelinə yönləndirilirsiniz...",
      });
      
      setTimeout(() => navigate('/ascorpadmin/dashboard'), 500);
    } catch (error) {
      const errorMessage = error.response?.data?.detail || "Email və ya parol səhvdir";
      toast({
        title: "Giriş uğursuz",
        description: errorMessage,
        variant: "destructive"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center px-4">
      <SEO title="Admin girişi" description="Admin panel" path="/ascorpadmin/entry" noindex />
      <Card className="w-full max-w-md border-2">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-700">
              <Lock className="h-8 w-8 text-white" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold">Admin Panel</CardTitle>
          <CardDescription>Daxil olmaq üçün məlumatlarınızı daxil edin</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="off"
                  placeholder="Elektron ünvanınız"
                  className="pl-10"
                  data-testid="admin-email-input"
                />
              </div>
            </div>
            <div>
              <Label htmlFor="password">Parol</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-3 h-5 w-5 text-gray-400 z-10" />
                <PasswordInput
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                  placeholder="••••••••"
                  className="pl-10"
                  data-testid="admin-password-input"
                />
              </div>
            </div>
            <Button 
              type="submit" 
              className="w-full bg-blue-700 hover:bg-blue-800" 
              size="lg"
              disabled={isSubmitting}
              data-testid="admin-login-btn"
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                  Giriş edilir...
                </>
              ) : (
                <>
                  <LogIn className="mr-2 h-5 w-5" />
                  Daxil ol
                </>
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
